import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workd/WORKD/PROJECT_2025/IKAMAI/LIVE/dashboard:client/layouts/default.vue").then(m => m.default || m)),
  admin: defineAsyncComponent(() => import("/workd/WORKD/PROJECT_2025/IKAMAI/LIVE/node_modules/.c12/gitlab_ikamai_nuxt_TrAk1AWn9h/layouts/admin.vue").then(m => m.default || m))
}